//PAGINA AINDA PRECISA SER VALIDADA - AINDA FALTA COMPREENSÃO POR PARTE DA REGRA DE NEGÓCIO
import "bootstrap/dist/css/bootstrap.min.css";
import "./Permission.css";

const roles = ["Sindicato", "Analista", "Administrador"];
const functionalities = [
  "Documentação - Envio",
  "Documentação - Análise",
  "Documentação - Extrato",
  "Pagamento - Liberação",
  "Configuração",
];

const PermissionTable = ({ functionalities }) => (
  <table className="table table-bordered permission-table">
    <thead>
      <tr>
        <th className="text-start">FUNCIONALIDADE</th>
        <th className="text-center">Visualizar</th>
        <th className="text-center">Editar</th>
        <th className="text-center">Excluir</th>
      </tr>
    </thead>
    <tbody>
      {functionalities.map((func, index) => (
        <tr key={index}>
          <td className="text-start">{func}</td>
          <td className="text-center">
            <input
              type="checkbox"
              defaultChecked
              className="form-check-input"
            />
          </td>
          <td className="text-center">
            <input type="checkbox" className="form-check-input" />
          </td>
          <td className="text-center">
            <input type="checkbox" className="form-check-input" />
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

const Permission = () => {
  return (
    <div className="container mt-4">
      <h1 className="doc-title">PERMISSÕES</h1>

      {roles.map((role, index) => (
        <div className="mb-4" key={index}>
          <h2 className="doc-section-title">{role}</h2>
          <PermissionTable functionalities={functionalities} />
        </div>
      ))}
    </div>
  );
};

export default Permission;
